// extracted by mini-css-extract-plugin
module.exports = {"bottom":"footer_bottom__26CyD","button":"footer_button__xuKTf"};